<wa-dialog label="Correction Assignments" style="--width: 80vw;" (waHide)="cancel()" open="true" withFooter="true">
  <div class="wa-grid wa-align-items-start wa-gap-xl">
    <div class="wa-stack">
      <h4>Fixed/Suggested</h4>
       <wa-scroller>
      @for (staffmember of fixedCorrectors; track staffmember.id) {
        <div class="alternating-component">
        <app-correction-fixed-staff-member
          [staffmember]="staffmember"
          (unfix)="setRegularStaffMember(staffmember)"/>
        </div>
        }
      <wa-divider></wa-divider>
      @for (staffmember of suggestedCorrectors; track staffmember.id) {
        <div class="alternating-component">
        <app-correction-fixed-staff-member
          [staffmember]="staffmember"
          (unfix)="setRegularStaffMember(staffmember)"/>
        </div>
        }
      </wa-scroller>
      </div>
    <div class="wa-stack">
      <h4>Staff</h4>
    <wa-scroller>
        @for (staffmember of staffMembers; track staffmember.id) {
        <div class="alternating-component">
        <app-correction-staff-member
          [staffmember]="staffmember"
          (fix)="setFixedStaffMember(staffmember)"
          (exclude)="setExcludedStaffMember(staffmember)"/>
        </div>
        }
      </wa-scroller>
      </div>
    <div class="wa-stack">
      <h4>Excluded</h4>
    <wa-scroller>
        @for (staffmember of excludedCorrectors; track staffmember.id) {
        <div class="alternating-component">
        <app-correction-excluded-staff-member
          [staffmember]="staffmember"
          (unexclude)="setRegularStaffMember(staffmember)"/>
        </div>
        }
      </wa-scroller>
      </div>
  </div>
  <div slot="footer">
    <div class="wa-cluster">
      <wa-button
        variant="brand"
        (click)="apply()">
        Close
      </wa-button>
    </div>
  </div>
</wa-dialog>
